import React, { createContext, useState, useContext, useEffect } from 'react'
import { api } from '../service/api'

const AuthContext = createContext()

function AuthProvider(props) {
  const [data, setData] = useState({})
  const userStorageKey = '@app:user'

  async function signIn(email, password) {
    try {
      const response = await api.post('/signin', {
        email,
        password
      })

      if (response.status !== 200) {
        return false
      }

      api.defaults.headers.authorization = `Bearer ${response.data.accessToken}`

      const userData = {
        accessToken: response.data.accessToken,
        user: {
          id: response.data.userId,
          ...response.data
          // id: response.data.userId,
          // email: response.data.email,
          // name: response.data.name,
          // permissions: response.data.permissions,
          // input_permissions: response.data.input_permissions,
          // is_account: response.data.is_account,
          // is_avaliador: response.data.is_avaliador,
          // cargo: response.data.cargo,
          // estado: response.data.estado,
          // cep: response.data.cep,
          // endereco: response.data.endereco,
          // observacao: response.data.observacao
        }
      }

      setData(userData)
      sessionStorage.setItem(userStorageKey, JSON.stringify(userData))
      return userData
    } catch (error) {
      console.log(error)
      if (error.status) return error
    }
  }

  async function signOut() {
    setData({})
    sessionStorage.removeItem(userStorageKey)
  }

  async function loadStorageData() {
    const userStoraged = await sessionStorage.getItem(userStorageKey)
    if (userStoraged) {
      const userLogged = JSON.parse(userStoraged)
      setData(userLogged)
      api.defaults.headers.authorization = `Bearer ${userLogged.accessToken}`
    }
  }

  useEffect(() => {
    loadStorageData()
  }, [])

  return (
    <AuthContext.Provider
      value={{
        signIn,
        signOut,
        user: data
      }}
    >
      {props.children}
    </AuthContext.Provider>
  )
}

function useAuth() {
  const context = useContext(AuthContext)
  return context
}

export { AuthProvider, useAuth }
